import {
    buildSchema,
} from "@camberi/firecms";

const eventSchema = buildSchema({
    name: "events",
    properties: {
        title: {
            dataType: "string",
            title: "Title",
            validation: {
                required: true
            }
        },
        description: {
            dataType: "string",
            title: "Description",
            validation: {
                required: true
            },
            config: {
                multiline: true
            }
        },

        link: {
            dataType: "string",
            title: "Event link",
            validation: {
                required: true
            }
        },

        available_dates: {
            dataType: "array",
            title: "Available Dates",
            // of: {
            //     dataType: "timestamp",
            // }
            of: {
                dataType: "map",
                properties: {
                    date: {
                        title: "Date",
                        dataType: "timestamp",
                        validation: {
                            required: true,
                        }
                    },

                }
            }

        },


        available_tickets: {
            dataType: "array",
            title: "Available tickets",
            validation: {
                required: true
            },
            of: {
                dataType: "map",
                properties: {
                    title: {
                        title: "Title",
                        dataType: "string",
                        config: {
                            enumValues: {
                                "Early Bird": "Early Bird",
                                "Standard": "Standard",
                            }
                        }
                    },
                    //  slug: {
                    //      title: "slug",
                    //      dataType: "string",
                    //      disabled: true,
                    //  },
                    price: {
                        title: "Price",
                        dataType: "string",
                        validation: {
                            required: true,
                        }
                    },
                }
            }

        },

        cover: {
            title: "Cover",
            dataType: "string",
            config: {
                storageMeta: {
                    mediaType: "image",
                    storagePath: "images",
                    acceptedFiles: ["image/*"],
                    storeUrl: true,
                }
            }
        },
        venue: {
            dataType: "map",
            title: "Venue",
            validation: {
                required: true
            },
            properties: {
                address: {
                    title: "Address",
                    dataType: "string"
                },
                lat: {
                    title: "Latitude",
                    dataType: "string"
                },
                lng: {
                    title: "Longitude",
                    dataType: "string"
                },
            }

        },
        created_at: {
            dataType: "timestamp",
            title: "Created_at",
            autoValue: "on_create"
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated_at",
            autoValue: "on_update"
        },
        publish: {
            dataType: "boolean",
            title: "Publish",
            validation: {
                required: true
            }
        },
    }
});

eventSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default eventSchema;